import { createNamespacedHelpers } from 'vuex'

const { mapState, mapActions } = createNamespacedHelpers('global_responses')

export default {
  computed: mapState({
    categories: (state) => state.categories,
    intents: (state) => state.intents,
    subIntents: (state) => state.subIntents,
    responses: (state) => state.responses,
    category: (state) => state.category,
    intent: (state) => state.intent,
    subIntent: (state) => state.subIntent,
    categoryReport: (state) => state.categoryReport,
    startDate: (state) => state.startDate,
    endDate: (state) => state.endDate,
    loading: (state) => state.loading,
  }),
  methods: mapActions([
    'loadCategories',
    'loadIntents',
    'loadSubIntents',
    'loadResponses',
    'setCategory',
    'setIntent',
    'setSubIntent',
    'setStartDate',
    'setCategoryReport',
    'setEndDate',
    'setLoading',
    'cleanState',
  ]),
}
